/** Tipos de contratación del empleado (fijos; los tipos de contrato documental se configuran aparte). */
export const TIPOS_CONTRATACION_EMPLEADO = ['Planilla', 'Recibo por Honorarios'];

/** Solo visible / válido cuando planilla alternativa está activa. */
export const TIPO_CONTRATACION_INTERNO = 'Interno';

export const obtenerTiposContratacionEmpleado = (planillaAlternativaActiva = false) =>
  planillaAlternativaActiva
    ? [...TIPOS_CONTRATACION_EMPLEADO, TIPO_CONTRATACION_INTERNO]
    : [...TIPOS_CONTRATACION_EMPLEADO];

export const esTipoContratacionEmpleadoValido = (valor, planillaAlternativaActiva = false) =>
  obtenerTiposContratacionEmpleado(planillaAlternativaActiva).includes(String(valor || '').trim());
